import { useTheme } from "@emotion/react";
import mergeProps from "./mergeProps.mjs";
import { setAutoFreeze, produce } from "immer";
setAutoFreeze(false);
function useThemeProps(_ref) {
  let {
    props,
    name,
    handleVariant = false,
    context = {}
  } = _ref;
  var _a, _b, _c, _d;
  const theme = useTheme();
  let {
    defaultProps = {},
    transformProps = []
  } = ((_a = theme.components) == null ? void 0 : _a[name]) || {};
  if (transformProps && !Array.isArray(transformProps)) {
    transformProps = [transformProps];
  }
  props = transformProps.reduce((props2, transform) => {
    return produce(props2, props3 => transform(props3, context));
  }, props);
  if (handleVariant) {
    let propsWithDefaults = mergeProps(defaultProps, props);
    let variant = propsWithDefaults.variant;
    const variantProps = variant && ((_d = (_c = (_b = theme.components) == null ? void 0 : _b[name]) == null ? void 0 : _c.variants) == null ? void 0 : _d[variant]) || {};
    defaultProps = mergeProps(defaultProps, variantProps);
  }
  props = mergeProps(defaultProps, props);
  if (handleVariant) {
    delete props.variant;
  }
  return props;
}
export { useThemeProps as default };